import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowLeftIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19 12H5M5 12L12 19M5 12L12 5'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={props.stroke ?? 'currentColor'}
      />
    </SvgIcon>
  );
};

export default ArrowLeftIcon;
